import { HttpErrorResponse } from '@angular/common/http';

import { ReferralTemplateBase } from '@recruitee/http-types';
import { createEntityCollectionStore } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<ReferralTemplateBase>()('ReferralsTemplateCollection', {
    idSelector: (entity: { id?: number | string | null }) => entity.id!,
    customActions: adapter => ({
      updatePositions: (state, payload: number[]) => adapter.markAsPending(state),
      updatePositionsSuccess: state => adapter.markAsLoaded(state),
      updatePositionsFailed: (state, payload: { error: HttpErrorResponse }) =>
        adapter.setError(state, payload.error),
    }),
  });

const ReferralsTemplateActions = <
  Pick<
    typeof actions,
    | 'fetchCollection'
    | 'fetchCollectionSuccess'
    | 'fetchCollectionFailed'
    | 'updatePositions'
    | 'updatePositionsSuccess'
    | 'updatePositionsFailed'
  >
>actions;

export {
  ReferralsTemplateActions,
  reducer as ReferralsTemplateReducer,
  selectors as ReferralsTemplateSelectors,
  namespace as ReferralsTemplateNamespace,
};
